import { Img, Picture, Source } from '@xo-union/tk-component-picture';
import { Subhead } from '@xo-union/tk-ui-typography';
import React, { useContext } from 'react';
import { TrackingContext } from '../../../TrackingContext';
import { Theme } from '../../PreviewPage/ThemeCard';
import styles from './index.scss';

interface Props {
  theme: Theme;
  paper: string;
}

const MatchingPaperInvitations: React.FC<Props> = ({ paper, theme }) => {
  const { track } = useContext(TrackingContext);

  const trackInvitation = () => {
    track('Matching Invitation links', {
      source: 'theme rail',
      themeName: theme?.name,
      current: true,
      page: 'preview',
      partnerName: theme?.themeDesigner?.companyName,
    });
  };

  return (
    <>
      <div className={styles.header}>
        <Subhead as="h2" className={styles.subheadMobile}>
          Match your website
        </Subhead>
      </div>
      <a href={theme.designerUrl || ''} onClick={trackInvitation} className={styles.invitationLinkMobile}>
        View matching designs on The Knot
      </a>

      <a className={styles.paperInvite} href={theme.designerUrl || ''} onClick={trackInvitation}>
        <div className={styles.freeSamples}>FREE samples</div>
        <Picture id={paper}>
          <Source viewport="xs" width={400} />
          <Source viewport="sm" width={800} />
          <Source viewport="md" width={400} />
          <Img width={400} />
        </Picture>
      </a>
      <div className={styles.copy}>
        Get three free stationery samples that match your Wedding Website with promo code <b>3FREE</b>.
      </div>
      <a href={theme.designerUrl || ''} onClick={trackInvitation} className={styles.invitationLink}>
        View matching designs on The Knot
      </a>
    </>
  );
};

export default MatchingPaperInvitations;
